/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { MdOutlineErrorOutline } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "../../../useStore";
import { reset } from "../../../features/Registration/registrationSlice";
import swal from "sweetalert";
import { EntriesPerPage, Search, TableFetch } from "../../../components/TableOptions";
import Pagination from "../../../components/Pagination";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import InterviewUpdateModal from "../../../components/ModalComponents/InterviewUpdateModal";
import ScheduleModal from "../../../components/ModalComponents/ScheduleModal";
import moment from "moment";
import FilterListIcon from "@mui/icons-material/FilterList";
import toast, { Toaster } from "react-hot-toast";
import XLoader from "../../../components/XLoader";
import DropOutModal from "../../../components/ModalComponents/DropOutModal";
import { getallapplicant } from "../../../features/Applicant/applicantSlice";
import PdfViewer from "../../../components/PdfViewer";
import { FaFileCsv, FaFilePdf, FaFileImage, FaFile } from "react-icons/fa";
import ImageLightbox from "../../../components/ImageLightbox";
import EditApplicant from "../../../components/ModalComponents/EditApplicant";
import ReplaceID from "../../../components/ModalComponents/ReplaceID";

const ActiveAssessmentTable = ({
  pageHeader,
  headerTitles,
  Status,
  statusButton,
  setResetID
}: any) => {

  const dispatch = useAppDispatch();
  const [searchItem, setSearchItem] = useState("");
  const [filter, setFilter] = useState([]);

  const {
    EvalvationisSuccess,
    UpdateScreeningStatusisSuccess,
    sendOfferisSuccess,
    applicationInterviewisSuccess,
    updateApplicationInterviewStatusisSuccess,
    sendEmailisSuccess,
    shareApplicationisSuccess,
    ScreeningisSuccess,
    applicationassignedisSuccess,
    scheduleApplicantisSuccess,
    updateInterviewStatusisSuccess,
    UpdateOfferisSuccess,
    sendForHireisSuccess,
    EditapplicantionisSuccess,
    sendForTranningisSuccess,
    updateTranningisSuccess,
    data,
    isError,
    isLoading,
    message,
  } = useAppSelector((state: { applicant: any }) => state.applicant);




  useEffect(() => {
    if (
      EvalvationisSuccess ||
      UpdateScreeningStatusisSuccess ||
      sendOfferisSuccess ||
      applicationInterviewisSuccess ||
      updateApplicationInterviewStatusisSuccess ||
      sendEmailisSuccess ||
      shareApplicationisSuccess ||
      ScreeningisSuccess ||
      applicationassignedisSuccess ||
      scheduleApplicantisSuccess ||
      updateInterviewStatusisSuccess ||
      UpdateOfferisSuccess ||
      sendForHireisSuccess ||
      EditapplicantionisSuccess ||
      sendForTranningisSuccess
    ) {
      const input = { interviewStatus: "PENDING" };
      // @ts-ignore 
      dispatch(getallapplicant(input))

      setTimeout(() => {
        dispatch(reset());
      }, 2000);
    }
  }, [EvalvationisSuccess, UpdateScreeningStatusisSuccess, sendOfferisSuccess, applicationInterviewisSuccess, updateApplicationInterviewStatusisSuccess, sendEmailisSuccess, shareApplicationisSuccess, ScreeningisSuccess, applicationassignedisSuccess, scheduleApplicantisSuccess, updateInterviewStatusisSuccess, dispatch, UpdateOfferisSuccess, sendForHireisSuccess, EditapplicantionisSuccess, sendForTranningisSuccess, updateTranningisSuccess]);

  const [show, setShow] = useState(false);
  const [isPDF, setIsPDF] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedIds, setSelectedIds] = useState<string[]>([]); // State to hold selected IDs
    const [selectedItems, setSelectedItems] = useState<any[]>([]); // State to hold selected items
  const handleCheckboxChange = (itemId: string, item: any) => {
    setIsDrawerOpen(true);
    // Check if the item's ID is already selected
    if (selectedIds.includes(itemId)) {
      // Remove the ID from the selectedIds array
      setSelectedIds(selectedIds.filter((id) => id !== itemId));
      setSelectedItems((prevSelectedItems) => prevSelectedItems.filter((i) => i.id !== itemId));
    } else {
      // Add the ID to the selectedIds array
      setSelectedIds([...selectedIds, itemId]);
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, item]);
    }
  };
  const openModal = (fileUrl, fileType, file) => {
    setSelectedFile(file);
    setIsPDF(fileType === 'pdf');
    setShow(true);
  };
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
   };



  const getFileIcon = (fileType: any) => {
    switch (fileType) {
      case 'pdf':
        return <FaFilePdf color={"red"} size={25} />;
      case 'csv':
        return <FaFileCsv size={25} color={"green"} />;
      case 'jpeg':
      case 'jpg':
      case 'png':
        return <FaFileImage size={25} color={"gray"} />;
      default:
        return <FaFile size={25} />;
    }
  };

  useEffect(() => {
    const input = { interviewStatus: "PENDING" };
    // @ts-ignore 
    dispatch(getallapplicant(input))

  }, [UpdateScreeningStatusisSuccess, dispatch]);


  useEffect(() => {
    if (isError) {
      swal({
        title: "error",
        text: message,
        icon: "error"
      })
      dispatch(reset())
    }
  }, [dispatch, isError, message])

  const [entriesperpage, setEntriesPerPage] = useState(() => {
    return "8";
  });





  useEffect(() => {
    const result = data?.data?.filter((item: any) =>
      item?.firstName?.toLowerCase()?.includes(searchItem) ||
      item?.middleName?.toLowerCase()?.includes(searchItem) ||
      item?.LastName?.toLowerCase()?.includes(searchItem)
    );
    setFilter(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchItem]);


  const [displayData, setDisplayData] = useState([]);


  const handleShow = () => {
    toast.success("Iterview have not been Completed")
  }





  return (
    <div>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 5000,
          error: {
            duration: 20000,
          },
        }}
      />
      <section className="md-ui component-data-table">
        <header className="main-table-header">
          <div className="main-table-search-container">
            <h1 className="table-header--title">{pageHeader}</h1>
            <Search
              searchItem={searchItem}
              setSearchItem={setSearchItem}
              placeholder={pageHeader}
            />
            <div>
              <EntriesPerPage
                data={filter}
                entriesperpage={entriesperpage}
                setEntriesPerPage={setEntriesPerPage}
              />
            </div>
            <span className="table-header--icons">
              <FilterListIcon />
            </span>
          </div>
        </header>
        {isLoading && <XLoader isLoading={isLoading} />}
        <div className="main-table-wrapper">
          <table className="main-table-content">
            <thead className="data-table-header">
              <tr className="data-table-row">
                {headerTitles.map((title: any, i: any) => (
                  <td className="table-datacell datatype-string headerTitles" key={i}  >
                    {title}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody className="data-table-content">
              {isLoading ? (
                <TableFetch colSpan={12} />
              ) : displayData?.length === undefined ||
                displayData?.length === 0 ? (
                <tr>
                  <td className="table-msg" colSpan={12}>
                    <MdOutlineErrorOutline size={75} />
                    <p>No Record found!</p>
                  </td>
                </tr>
              ) : (
                displayData?.map((item: any, i: any) => (
                  <tr key={i}>              
                    <td className="table-datacell datatype-string">
                      <div className="dropdown">
                        <button className="dropbtn">
                          <MoreHorizIcon />
                        </button>
                        <div className="dropdown-content">
                          <a>
                            <ScheduleModal
                              title="Schedule"
                              applicationId={item.id}
                              name={`${!item?.firstName ? "" : item?.firstName} ${!item?.middleName ? "" : item.middleName} ${!item?.LastName ? "" : item?.LastName}`.trim()}
                              id={item?.InterviewLog?.id}
                            />
                          </a>
                          <a>
                            <DropOutModal
                              title="Dropout"
                              id={item?.id}
                              name={`${!item?.firstName ? "" : item?.firstName} ${!item?.middleName ? "" : item.middleName} ${!item?.LastName ? "" : item?.LastName}`.trim()}
                            />

                          </a>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="dropdown">

                        <InterviewUpdateModal
                          disabled={item?.Schedule?.length === 0}
                          title="Update Interview Status"
                          nametitle={item.title}
                          name={`${item.firstName} ${item.middleName} ${item.LastName}`}
                          id={item?.InterviewLog?.id}
                          email={item?.email}
                        />

                      </div>

                    </td>

                    <td className="table-datacell datatype-numeric toggle">
                      {item?.firstName} {item?.middleName} {item?.LastName}
                      {pageHeader.includes("History")}
                    </td>
                    <td className="table-datacell datatype-string">
                      {item?.gender}
                    </td>
                    <td className="table-datacell datatype-string">
                      {moment(!item?.dateOfBirth ? "n/a" : item?.dateOfBirth).format("DD-MM-YYYY")}
                    </td>
                    <td className="table-datacell datatype-string">
                      <Link
                        to={`/viewapplicants/${item?.id}`}
                        className="applicant-btn"
                      >
                        <Button className="view-job-profile">View</Button>
                      </Link>
                    </td>
                    <td className="table-datacell datatype-string">
                      {item?.verificationID
                        ? (

                          <div className="table-datacell-flex">
                          <span
                            style={{ marginRight: '5px', cursor: 'pointer' }}
                            onClick={() => {
                              const fileExtension = item?.verificationID.split('.').pop().toLowerCase();
                              openModal(item?.verificationID, fileExtension, item?.verificationID,);
                            }}>
                            {getFileIcon(item?.verificationID.split('.').pop().toLowerCase())}
                          </span>
                          <ReplaceID id={item?.id} setResetID={setResetID} />
                          </div>
                        )
                        : <div className="table-datacell-flex">
                           <span>
                            No ID
                           </span>
                            <ReplaceID id={item?.id} setResetID={setResetID} />
                          </div>
                      }
                    </td>
                    <td className="table-datacell datatype-string">
                      {moment(item?.createdAt).format("DD-MM-YYYY")}
                    </td>
                    <td className="table-datacell datatype-string">
                      {moment(item?.updatedAt).format("DD-MM-YYYY")}
                    </td>
                    <td className="table-datacell datatype-numeric">
                      <Button className={statusButton}
                      >{item?.InterviewLog?.interviewStatus === "PENDING" ? Status : "COMPLETED"}</Button>
                    </td>

                    <td className="table-datacell datatype-numeric">
                      {item?.email}
                    </td>

                    <td className="table-datacell datatype-string">
                      {item?.phoneNumber}
                    </td>

                    <td className="table-datacell datatype-string">
                      {item?.totalWorkExperience}
                    </td>
                    <td className="table-datacell datatype-string">
                      {item?.relevantWorkExperience}
                    </td>
                    <td className="table-datacell datatype-string">
                      <EditApplicant name={item} id={item?.id} />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {isPDF ? (
            <PdfViewer fileUrl={selectedFile} setShow={setShow} show={show} />
          ) : (
            <ImageLightbox images={selectedFile} setShow={setShow} show={show} />
          )}
        </div>
        <div className="table-footer">
          <div>
            <Pagination
              setDisplayData={setDisplayData}
              data={filter}
              entriesperpage={entriesperpage}
              Total={"Applicant"}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ActiveAssessmentTable;